export default __webpack_public_path__ + "static/konstantin-bulenkov-aa90200b4ded44b6c1aaeeaeba8db3e5.png";